import React from 'react';
import { ArrowUpRight, ShoppingCart, Banknote, Landmark, Network } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { openWhatsApp } from '../constants';
import { Reveal, SectionHeading } from './ui-blocks';

const CRYPTO_IMAGE =
  'https://images.unsplash.com/photo-1640833906651-6bd1af7aeea3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200';

const ICONS = [ShoppingCart, Banknote, Landmark, Network];
const SPANS = ['lg:col-span-7', 'lg:col-span-5', 'lg:col-span-5', 'lg:col-span-7'];

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" data-testid="services-section" className="noise relative bg-bordeaux text-cream py-24 md:py-32 overflow-hidden">
      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionHeading eyebrow={t.services.eyebrow} title={t.services.title} subtitle={t.services.subtitle} light testId="services-heading" />
          <Reveal delay={0.2}>
            <span className="font-heading text-6xl md:text-7xl text-cream/15 leading-none">04</span>
          </Reveal>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-3" data-testid="services-grid">
          {t.services.items.map((service, index) => {
            const Icon = ICONS[index];
            const withImage = index === 2;
            return (
              <Reveal key={service.title} delay={index * 0.08} className={SPANS[index]}>
                <article
                  data-testid={`service-card-${index}`}
                  onClick={openWhatsApp}
                  className="group relative h-full min-h-[280px] md:min-h-[320px] flex flex-col justify-between p-8 md:p-10 bg-bordeaux-dark border border-cream/10 hover:border-gold hover:-translate-y-1 transition-[border-color,transform] duration-300 cursor-pointer overflow-hidden"
                >
                  {withImage && (
                    <>
                      <img src={CRYPTO_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500" />
                      <div className="absolute inset-0 bg-gradient-to-t from-bordeaux-dark via-bordeaux-dark/80 to-transparent" />
                    </>
                  )}
                  <div className="relative flex items-start justify-between">
                    <span className="w-12 h-12 flex items-center justify-center border border-gold/40 text-gold">
                      <Icon className="w-5 h-5" strokeWidth={1.5} />
                    </span>
                    <span className="text-xs font-bold tracking-[0.2em] text-cream/40">0{index + 1}</span>
                  </div>
                  <div className="relative mt-12">
                    <h3 className="font-heading text-2xl md:text-3xl leading-tight">{service.title}</h3>
                    <p className="mt-4 text-cream/65 leading-relaxed max-w-md">{service.description}</p>
                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-gold opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300">
                      {t.nav.whatsapp}
                      <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
